'use strict';

var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var jsxRuntime = require('react/jsx-runtime');

var l=({children:o,textAlign:s,className:e})=>{let a={textAlign:s};return jsxRuntime.jsx("div",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-chat-card ${e||""}`),style:a,children:o})},c=l;

exports.a = c;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-BP2XTNEO.js.map